import { HonorariumType } from "../shared/enums/HonorariumType";
import { PaymentType } from "../shared/enums/PaymentType";

export class Additive {
    honorarium: HonorariumType = 0;
    totalValue: number;
    mensalHours: Number; // horas mensais de contrato
    soldHourValue: Number; //valor das horas vendidas
    hourValue: number;
    additiveType: number = 0;
    date: string;
    oldCompanyName: String;
    oldCnpj: String;
    oldCompanyAddress: String;
    oldCompanyNumber: String;
    oldCompanyComplement: String;
    oldCompanyCep: String;
    oldCompanyCity: String;
    oldCompanyDistrict: String;
    oldCompanyState: String;
    cnae: String;
    pendingApproval: Boolean = false;
    pendingGovApproval: Boolean = false;
    createdAt: string;

    populateFromServer(r: any){
        if(r.honorarium)
            this.honorarium = r.honorarium;

        if(r.totalValue != undefined)
            this.totalValue = r.totalValue;

        if(r.mensalHours != undefined)
            this.mensalHours = r.mensalHours;

        if(r.soldHourValue != undefined)
            this.soldHourValue = r.soldHourValue;

        if(r.hourValue != undefined)
            this.hourValue = r.hourValue;

        if(r.additiveType)
            this.additiveType = r.additiveType;

        if(r.date)
            this.date = r.date;

        if(r.oldCompanyName)
            this.oldCompanyName = r.oldCompanyName;

        if(r.oldCnpj)
            this.oldCnpj = r.oldCnpj;

        if(r.oldCompanyAddress)
            this.oldCompanyAddress = r.oldCompanyAddress;

        if(r.oldCompanyNumber)
            this.oldCompanyNumber = r.oldCompanyNumber;

        if(r.oldCompanyComplement)
            this.oldCompanyComplement = r.oldCompanyComplement;

        if(r.oldCompanyCep)
            this.oldCompanyCep = r.oldCompanyCep;

        if(r.oldCompanyCity)
            this.oldCompanyCity = r.oldCompanyCity;

        if(r.oldCompanyDistrict)
            this.oldCompanyDistrict = r.oldCompanyDistrict;

        if(r.oldCompanyState)
            this.oldCompanyState = r.oldCompanyState;

        if(r.cnae)
            this.cnae = r.cnae;

        if(r.pendingApproval)
            this.pendingApproval = r.pendingApproval;

        if(r.pendingGovApproval)
            this.pendingGovApproval = r.pendingGovApproval;

        if (r.createdAt)
            this.createdAt = r.createdAt;

    }
}



// WEBPACK FOOTER //
// ./src/app/models/Additive.model.ts